export default __webpack_public_path__ + "static/media/share.a667014e.svg";